<template>
  <div class="DetailFormatPanel">
    <no-ssr>
      <div class="panel-pic-info">
        <div class="dd">
          <div
            class="pic-item">
            <div class="title">文件格式</div>
            <div class="desc">
              <template v-if="detail.is_ai == 0">{{ detail.layout_name | disposeLayoutName  }}</template>
              <template v-if="detail.is_ai == 1">JPG/PNG</template>

            </div>
          </div>
          <div
            class="pic-item">
            <div class="title">图片大小</div>
            <div class="desc">{{ detail.file_size }}MB</div>
          </div>
          <div
            class="pic-item">
            <div class="title">图片尺寸</div>
            <div class="desc">{{ detail.image_width }}px*{{ detail.image_height }}px</div>
          </div>

          <div
            v-if="detail.is_ai == 0"
            class="pic-item">
            <div class="title">作者</div>
            <div class="desc">{{ detail.uid }}</div>
          </div>
          <div
            class="pic-item pic-item-font" v-if="detail.fonts && detail.fonts.length">
            <div class="title">使用字体
                <i class="iconfont icon-question" v-if="detail.fontStr.indexOf('字魂') > -1">
                  <div class="hover-txt">
                    {{ "本作品字体含版权内容,商用请另行购买授权" }}
                  </div>
                </i>
            </div>
            <div class="desc ">
              <span class="overflow-one">{{ detail.fontStr }}</span>
              <div class="hover-txt">
                {{ detail.fontStr }}
              </div>
            </div>
          </div>
<!--          <div  v-if="detail.is_ai == 0"
            class="pic-item pic-item-rj">
            <div class="title">适用软件</div>
            <div class="desc">
              <div
                v-for="vo in detail.iconClass"
                :key="vo"
                class="icon-box"
              >
                <i :class="vo"/>
                <div class="hover-txt">
                  {{ vo | iconClassHoverText }}
                </div>
              </div>
            </div>
          </div>-->

          <div  v-if="detail.renderer.length"
                class="pic-item pic-item-rj">
            <div class="title">渲染器</div>
            <div class="desc">
              <div
                  v-for="vo in detail.renderer"
                  :key="vo"
                  class="icon-box"
              >
                {{ vo }}
<!--                <i :class="vo"/>
                <div class="hover-txt">
                  {{ vo }}
                </div>-->
              </div>
            </div>
          </div>

        </div>


      </div>
    </no-ssr>
  </div>
</template>

<script>
import { PAGE_PATH } from '@/constant/PAGE_PATH'
export default {
  name: "DetailFormatPanel",
  mixins: [],
  props: {
    /* 详情 */
    detail: {
      type: Object,
      default: () => {
      }
    },
  },
  data(){
    return{
      PAGE_PATH
    }
  },
  filters:{
    disposeLayoutName(val) {
      if (Array.isArray(val)) {
        return val.join(' / ')
      } else {
        return val;
      }
    },
    disposePrice(val) {
      return parseFloat(val).toFixed(1);
    },

    iconClassHoverText(val) {
      switch (val) {
        case 'icon_ps':
          return 'Adobe Photoshop';
        case 'icon_3dMax':
          return '3D Max';
        case 'icon_cdr':
          return 'Coreldraw';
        case 'icon_ai':
          return 'Adobe lllustrator';
        case 'icon_c4d':
          return 'Cinema 4D';
        case 'icon_sketch':
          return 'Sketch App';
        case 'icon_blender':
          return 'Blender';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "components/tupian/common/common";

.DetailFormatPanel{
  position: relative;
  width: 434px;
  margin-top: 32px;
  &:after{
    content: '';
    width: 100%;
    height: 56px;
    display: inline-block;
    background: linear-gradient(180deg, #F5F6FA 0%, rgba(245,246,250,0) 100%);
    border-radius: 14px;
    @include Position(1,5,0,0);
  }
}
.panel-pic-info {
  width: 434px;
  //height: 320px;
  //height: 372px;
  //background: linear-gradient(180deg, rgba(245, 246, 250, 0) 0%, #F5F6FA 51%, rgba(245, 246, 250, 0) 100%);
  border-radius: 14px;
  padding: 24px 0 18px 26px;
  box-sizing: border-box;



  .dt {
    margin-bottom: 12px;

    .icon_image {
      //@include IconFont(24px, #35D0BA)
      @include BgImage(24px, 24px, 'tupian/detail/all.svg');
    }

    .icon_ji {
      @include BgImage(24px, 24px, 'tupian/detail/label.svg');
    }

    .icon-calendar {
      @include IconFont(24px, #35D0BA)
    }
  }

  .dd {
    display: flex;
    //margin-bottom: 18px;
    flex-wrap: wrap;

    &:last-child {
      margin-bottom: 0;
    }

    .pic-item {
      width: 124px;
      //height: 42px;
      border-radius: 2px;
      margin-bottom: 16px;

      .title {
        margin-bottom: 4px;
        height: 18px;
        font-size: 13px;
        color: rgba(89, 96, 136, 0.65);
        line-height: 17px;
        letter-spacing: 1px;

        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #596088;
        line-height: 16px;
        letter-spacing: 1px;
      }

      .desc {
        font-size: 14px;
        font-weight: bold;
        color: rgba(89, 96, 136, 0.85);
        line-height: 20px;

        font-size: 13px;
        font-weight: bold;
        color: rgba(89, 96, 136, 0.7);
        line-height: 18px;

        .icon-box{
          font-weight: bold;
        }

      }
    }

    .pic-item-bq {
      width: 100%;
      margin-bottom: 0;

      .pic-tag {
        display: flex;
        flex-wrap: wrap;
        padding-right: 30px;

        a {
          //width: 42px;
          padding: 0 8px;
          height: 26px;
          line-height: 26px;
          background: #F5F6FA;
          border-radius: 13px;
          font-size: 13px;
          color: #596088;
          margin: 0 8px 8px 0;

          @include ElementHover(#6969FF, #EEEEFF);

        }
      }
    }

    .pic-item-font {

      .icon-question{
        position: relative;
        @include ElementHover('', '') {
          .hover-txt {
            display: block !important;
          }
        }

        .hover-txt{
          max-width: 152px;
          width: 152px;
        }
      }
      .hover-txt {
        position: absolute;
        //white-space:nowrap;
        display: none;
        max-width: 130px;
        box-sizing: border-box;
        top: 26px;
        left: -6px;
        //height: 28px;
        padding: 4px 8px;
        line-height: 24px;
        background: #424866;
        border-radius: 6px;
        color: #FFFFFF;
        font-size: 12px;
        z-index: 10;

        &:after {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          @include Position(1, 5, 14px, -3px);
          background: #424866;
          transform: rotate(135deg);
          border-radius: 1px;
        }
      }

      .desc {
        position: relative;

        span {
          width: 100px;
          display: inline-block;
        }

        @include ElementHover('', '') {
          .hover-txt {
            display: block !important;
          }
        }




      }
    }

  }

  .create-time {
    .pic-item {
      width: 186px;
      height: 42px;
    }
  }

  .application {
    .pic-item {
      .title {
        margin-bottom: 8px;
      }
    }

    .desc {
      display: flex;
    }

    .icon_ps {
      @include BgImage(26px, 26px, "home/images/application/icon-ps.svg");
      margin-right: 9px;
    }

    .icon_sketch {
      @include BgImage(26px, 26px, "home/images/application/icon-sketch.svg");
    }
  }

}
</style>
